import { readTemplate } from '@next-adapter/template-reader/read-template.js'

export function tryReadCoreManagedTemplate(relativeOutputPath: string): string | null {
  try {
    return readTemplate(relativeOutputPath)
  } catch {
    return null
  }
}
